import { render, staticRenderFns } from "./conversationsDetail.vue?vue&type=template&id=7f35f9c9&scoped=true&"
import script from "./conversationsDetail.vue?vue&type=script&lang=js&"
export * from "./conversationsDetail.vue?vue&type=script&lang=js&"
import style0 from "./conversationsDetail.vue?vue&type=style&index=0&id=7f35f9c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f35f9c9",
  null
  
)

export default component.exports